import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-open",
  "use": "close-open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close-open\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M12 21a9 9 0 110-18 9 9 0 010 18m0-20a11 11 0 100 22 11 11 0 000-22M15.5 14.1l-2-2.1 2-2.1a1 1 0 00-1.4-1.4l-2.1 2-2.1-2a1 1 0 00-1.4 1.4l2 2.1-2 2.1a1 1 0 001.4 1.4l2.1-2 2.1 2a1 1 0 001.4-1.4\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol